module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/Periscopic Telephoto Camera.e1a7e103.png";